import { render, staticRenderFns } from "./WebsiteForms.vue?vue&type=template&id=25db06d6&scoped=true&"
import script from "./WebsiteForms.vue?vue&type=script&lang=js&"
export * from "./WebsiteForms.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteForms.vue?vue&type=style&index=0&id=25db06d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25db06d6",
  null
  
)

export default component.exports